import moment from 'moment';
import { CITIZENSHIP_TYPE } from '../constants/citizenship';
import { PERMITTED_DOCUMENTS as PERMITTED_DOCUMENTS_VALUES } from '../store/passport/permittedDocuments';
import { DATE_FORMAT } from './date';

const PERSON_TYPE = {
  PARTICIPANT: 'PARTICIPANT',
  PARENT: 'PARENT',
  CHILD: 'CHILD',
};

const AGE_TYPE = {
  OLDER_THAN_FOURTEEN_YEARS: 'OLDER_THAN_14_YEARS',

  YOUNGER_THAN_FOURTEEN_YEARS: 'YOUNGER_THAN_14_YEARS',
  BETWEEN_FOURTEEN_YEARS_AND_FOURTEEN_YEARS_THIRTY_ONE_DAY:
    'BETWEEN_14_YEARS_AND_14_YEARS_31_DAY',
  BETWEEN_FOURTEEN_YEARS_AND_FOURTEEN_YEARS_180_DAYS:
    'BETWEEN_FOURTEEN_YEARS_AND_FOURTEEN_YEARS_180_DAYS',
  BETWEEN_FOURTEEN_YEARS_THIRTY_ONE_DAY_AND_SIXTEEN_YEARS:
    'BETWEEN_14_YEARS_31_DAY_AND_16_YEARS',
  OLDER_THAN_SIXTEEN_YEARS: 'OLDER_THAN_16_YEARS',
};

const PERMITTED_DOCUMENTS = {
  [PERSON_TYPE.PARTICIPANT]: {
    [AGE_TYPE.BETWEEN_FOURTEEN_YEARS_AND_FOURTEEN_YEARS_THIRTY_ONE_DAY]: {
      [CITIZENSHIP_TYPE.CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_RF,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
      [CITIZENSHIP_TYPE.DUAL]: [
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_RF,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
      [CITIZENSHIP_TYPE.FOREIGN_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_RF,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
      [CITIZENSHIP_TYPE.NON_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_RF,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
    },
    [AGE_TYPE.BETWEEN_FOURTEEN_YEARS_AND_FOURTEEN_YEARS_180_DAYS]: {
      [CITIZENSHIP_TYPE.CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.PASSPORT_RF,
        PERMITTED_DOCUMENTS_VALUES.DIPLOMATIC_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.SERVICE_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.OFFICER_ID,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_ID,
        PERMITTED_DOCUMENTS_VALUES.MILITARY_ID,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_RF,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
      [CITIZENSHIP_TYPE.DUAL]: [
        PERMITTED_DOCUMENTS_VALUES.PASSPORT_RF,
        PERMITTED_DOCUMENTS_VALUES.DIPLOMATIC_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.SERVICE_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.OFFICER_ID,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_ID,
        PERMITTED_DOCUMENTS_VALUES.MILITARY_ID,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_RF,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
      [CITIZENSHIP_TYPE.FOREIGN_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.FOREIGN_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_RESIDENT_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.RESIDENCE,
        PERMITTED_DOCUMENTS_VALUES.RF_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_ID,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_CONSIDERATION,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_REFUGEE_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_RF,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
      [CITIZENSHIP_TYPE.NON_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.FOREIGN_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_RESIDENT_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.RESIDENCE,
        PERMITTED_DOCUMENTS_VALUES.RF_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_ID,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_CONSIDERATION,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_REFUGEE_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_RF,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
    },
    [AGE_TYPE.BETWEEN_FOURTEEN_YEARS_THIRTY_ONE_DAY_AND_SIXTEEN_YEARS]: {
      [CITIZENSHIP_TYPE.CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.PASSPORT_RF,
        PERMITTED_DOCUMENTS_VALUES.DIPLOMATIC_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.SERVICE_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.OFFICER_ID,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_ID,
        PERMITTED_DOCUMENTS_VALUES.MILITARY_ID,
      ],
      [CITIZENSHIP_TYPE.DUAL]: [
        PERMITTED_DOCUMENTS_VALUES.PASSPORT_RF,
        PERMITTED_DOCUMENTS_VALUES.DIPLOMATIC_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.SERVICE_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.OFFICER_ID,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_ID,
        PERMITTED_DOCUMENTS_VALUES.MILITARY_ID,
      ],
      [CITIZENSHIP_TYPE.FOREIGN_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.FOREIGN_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_RESIDENT_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.RESIDENCE,
        PERMITTED_DOCUMENTS_VALUES.RF_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_ID,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_CONSIDERATION,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_REFUGEE_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
      [CITIZENSHIP_TYPE.NON_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.FOREIGN_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_RESIDENT_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.RESIDENCE,
        PERMITTED_DOCUMENTS_VALUES.RF_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_ID,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_CONSIDERATION,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_REFUGEE_PERMIT,
      ],
    },
    [AGE_TYPE.OLDER_THAN_SIXTEEN_YEARS]: {
      [CITIZENSHIP_TYPE.CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.PASSPORT_RF,
        PERMITTED_DOCUMENTS_VALUES.DIPLOMATIC_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.SERVICE_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.OFFICER_ID,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_ID,
        PERMITTED_DOCUMENTS_VALUES.MILITARY_ID,
      ],
      [CITIZENSHIP_TYPE.DUAL]: [
        PERMITTED_DOCUMENTS_VALUES.PASSPORT_RF,
        PERMITTED_DOCUMENTS_VALUES.DIPLOMATIC_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.SERVICE_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.OFFICER_ID,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_ID,
        PERMITTED_DOCUMENTS_VALUES.MILITARY_ID,
      ],
      [CITIZENSHIP_TYPE.FOREIGN_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.FOREIGN_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_RESIDENT_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.RESIDENCE,
        PERMITTED_DOCUMENTS_VALUES.RF_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_ID,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_CONSIDERATION,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_REFUGEE_PERMIT,
      ],
      [CITIZENSHIP_TYPE.NON_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.FOREIGN_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_RESIDENT_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.RESIDENCE,
        PERMITTED_DOCUMENTS_VALUES.RF_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_ID,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_CONSIDERATION,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_REFUGEE_PERMIT,
      ],
    },
  },
  [PERSON_TYPE.CHILD]: {
    [AGE_TYPE.YOUNGER_THAN_FOURTEEN_YEARS]: {
      [CITIZENSHIP_TYPE.CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_RF,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
      [CITIZENSHIP_TYPE.DUAL]: [
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_RF,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
      [CITIZENSHIP_TYPE.FOREIGN_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
      [CITIZENSHIP_TYPE.NON_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
    },
    [AGE_TYPE.BETWEEN_FOURTEEN_YEARS_AND_FOURTEEN_YEARS_THIRTY_ONE_DAY]: {
      [CITIZENSHIP_TYPE.CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_RF,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
      [CITIZENSHIP_TYPE.DUAL]: [
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_RF,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
      [CITIZENSHIP_TYPE.FOREIGN_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_RF,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
      [CITIZENSHIP_TYPE.NON_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.FOREIGN_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_RESIDENT_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.RESIDENCE,
        PERMITTED_DOCUMENTS_VALUES.RF_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_ID,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_CONSIDERATION,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_REFUGEE_PERMIT,
      ],
    },
    [AGE_TYPE.BETWEEN_FOURTEEN_YEARS_AND_FOURTEEN_YEARS_180_DAYS]: {
      [CITIZENSHIP_TYPE.CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.PASSPORT_RF,
        PERMITTED_DOCUMENTS_VALUES.DIPLOMATIC_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.SERVICE_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.OFFICER_ID,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_ID,
        PERMITTED_DOCUMENTS_VALUES.MILITARY_ID,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_RF,
      ],
      [CITIZENSHIP_TYPE.DUAL]: [
        PERMITTED_DOCUMENTS_VALUES.PASSPORT_RF,
        PERMITTED_DOCUMENTS_VALUES.DIPLOMATIC_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.SERVICE_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.OFFICER_ID,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_ID,
        PERMITTED_DOCUMENTS_VALUES.MILITARY_ID,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_RF,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
      [CITIZENSHIP_TYPE.FOREIGN_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.FOREIGN_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_RESIDENT_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.RESIDENCE,
        PERMITTED_DOCUMENTS_VALUES.RF_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_ID,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_CONSIDERATION,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_REFUGEE_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
      [CITIZENSHIP_TYPE.NON_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.FOREIGN_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_RESIDENT_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.RESIDENCE,
        PERMITTED_DOCUMENTS_VALUES.RF_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_ID,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_CONSIDERATION,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_REFUGEE_PERMIT,
      ],
    },
    [AGE_TYPE.BETWEEN_FOURTEEN_YEARS_THIRTY_ONE_DAY_AND_SIXTEEN_YEARS]: {
      [CITIZENSHIP_TYPE.CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.PASSPORT_RF,
        PERMITTED_DOCUMENTS_VALUES.DIPLOMATIC_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.SERVICE_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.OFFICER_ID,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_ID,
        PERMITTED_DOCUMENTS_VALUES.MILITARY_ID,
      ],
      [CITIZENSHIP_TYPE.DUAL]: [
        PERMITTED_DOCUMENTS_VALUES.PASSPORT_RF,
        PERMITTED_DOCUMENTS_VALUES.DIPLOMATIC_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.SERVICE_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.OFFICER_ID,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_ID,
        PERMITTED_DOCUMENTS_VALUES.MILITARY_ID,
      ],
      [CITIZENSHIP_TYPE.FOREIGN_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.FOREIGN_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_RESIDENT_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.RESIDENCE,
        PERMITTED_DOCUMENTS_VALUES.RF_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_ID,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_CONSIDERATION,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_REFUGEE_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.BIRTH_CERTIFICATE_INTERNATIONAL,
      ],
      [CITIZENSHIP_TYPE.NON_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.FOREIGN_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_RESIDENT_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.RESIDENCE,
        PERMITTED_DOCUMENTS_VALUES.RF_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_ID,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_CONSIDERATION,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_REFUGEE_PERMIT,
      ],
    },
    [AGE_TYPE.OLDER_THAN_SIXTEEN_YEARS]: {
      [CITIZENSHIP_TYPE.CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.PASSPORT_RF,
        PERMITTED_DOCUMENTS_VALUES.DIPLOMATIC_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.SERVICE_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.OFFICER_ID,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_ID,
        PERMITTED_DOCUMENTS_VALUES.MILITARY_ID,
      ],
      [CITIZENSHIP_TYPE.DUAL]: [
        PERMITTED_DOCUMENTS_VALUES.PASSPORT_RF,
        PERMITTED_DOCUMENTS_VALUES.DIPLOMATIC_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.SERVICE_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.OFFICER_ID,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_ID,
        PERMITTED_DOCUMENTS_VALUES.MILITARY_ID,
      ],
      [CITIZENSHIP_TYPE.FOREIGN_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.FOREIGN_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_RESIDENT_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.RESIDENCE,
        PERMITTED_DOCUMENTS_VALUES.RF_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_ID,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_CONSIDERATION,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_REFUGEE_PERMIT,
      ],
      [CITIZENSHIP_TYPE.NON_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.FOREIGN_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_RESIDENT_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.RESIDENCE,
        PERMITTED_DOCUMENTS_VALUES.RF_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_ID,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_CONSIDERATION,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_REFUGEE_PERMIT,
      ],
    },
  },
  [PERSON_TYPE.PARENT]: {
    [AGE_TYPE.OLDER_THAN_FOURTEEN_YEARS]: {
      [CITIZENSHIP_TYPE.CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.PASSPORT_RF,
        PERMITTED_DOCUMENTS_VALUES.DIPLOMATIC_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.SERVICE_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.OFFICER_ID,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_ID,
        PERMITTED_DOCUMENTS_VALUES.MILITARY_ID,
      ],
      [CITIZENSHIP_TYPE.DUAL]: [
        PERMITTED_DOCUMENTS_VALUES.PASSPORT_RF,
        PERMITTED_DOCUMENTS_VALUES.DIPLOMATIC_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.SERVICE_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.OFFICER_ID,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_ID,
        PERMITTED_DOCUMENTS_VALUES.MILITARY_ID,
      ],
      [CITIZENSHIP_TYPE.FOREIGN_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.FOREIGN_PASSPORT,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_RESIDENT_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.RESIDENCE,
        PERMITTED_DOCUMENTS_VALUES.RF_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_ID,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_CONSIDERATION,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_REFUGEE_PERMIT,
      ],
      [CITIZENSHIP_TYPE.NON_CITIZEN]: [
        PERMITTED_DOCUMENTS_VALUES.FOREIGN_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_RESIDENT_PERMIT,
        PERMITTED_DOCUMENTS_VALUES.RESIDENCE,
        PERMITTED_DOCUMENTS_VALUES.RF_NON_CITIZEN_DOC,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_ID,
        PERMITTED_DOCUMENTS_VALUES.REFUGEE_CONSIDERATION,
        PERMITTED_DOCUMENTS_VALUES.TEMPORARY_REFUGEE_PERMIT,
      ],
    },
  },
};

export const getPermittedDocuments = (
  personType,
  birthdate,
  citizenshipType,
) => {
  if (personType === PERSON_TYPE.PARENT) {
    return PERMITTED_DOCUMENTS[PERSON_TYPE.PARENT][
      AGE_TYPE.OLDER_THAN_FOURTEEN_YEARS
    ][citizenshipType];
  }

  const momentBirthdate = moment(birthdate, DATE_FORMAT);

  const fourteenYearsAgo = moment().subtract(14, 'years');
  const fourteenYearsAndThirtyOneDayAgo = moment()
    .subtract(14, 'years')
    .subtract(31, 'days');
  const fourteenYearsAndHalfAgo = moment()
    .subtract(14, 'years')
    .subtract(180, 'days');
  const sixteenYearsAgo = moment().subtract(16, 'years');

  let ageType;

  if (momentBirthdate.isBefore(sixteenYearsAgo)) {
    ageType = AGE_TYPE.OLDER_THAN_SIXTEEN_YEARS;
  } else if (
    momentBirthdate.isAfter(fourteenYearsAndThirtyOneDayAgo) &&
    momentBirthdate.isBefore(fourteenYearsAgo)
  ) {
    ageType = AGE_TYPE.BETWEEN_FOURTEEN_YEARS_AND_FOURTEEN_YEARS_THIRTY_ONE_DAY;
  } else if (
    momentBirthdate.isAfter(fourteenYearsAndHalfAgo) &&
    momentBirthdate.isBefore(fourteenYearsAgo)
  ) {
    ageType = AGE_TYPE.BETWEEN_FOURTEEN_YEARS_AND_FOURTEEN_YEARS_180_DAYS;
  } else if (
    momentBirthdate.isAfter(sixteenYearsAgo) &&
    momentBirthdate.isBefore(fourteenYearsAndThirtyOneDayAgo)
  ) {
    ageType = AGE_TYPE.BETWEEN_FOURTEEN_YEARS_THIRTY_ONE_DAY_AND_SIXTEEN_YEARS;
  } else {
    ageType = AGE_TYPE.YOUNGER_THAN_FOURTEEN_YEARS;
  }

  if (!PERMITTED_DOCUMENTS[personType][ageType]) {
    return [];
  }

  return PERMITTED_DOCUMENTS[personType][ageType][citizenshipType];
};
